<template>
  <div>
    <span
      v-if="value == '#NA#'"
      class="na-grid-cell"
    >
      N/A
    </span>

    <span
      v-else-if="value == '#NREF#'"
      class="nref-grid-cell"
    >⠀</span>

    <span v-else>{{ value }}</span>
  </div>
</template>

<script>
import { isNil } from 'lodash'
export default {
  name: 'NumberCellRenderer',
  data () {
    return {
      value: ''
    }
  },
  beforeMount () {
    if ((this.params.data && this.params.column ? this.params.data[this.params.column.colId] === undefined : false) && this.params.nref) {
      this.value = '#NREF#'
    } else {
      let value = this.params.value === '' ? null : this.params.value
      if (value !== '#NA#' && value !== '#NREF#') {
        if (typeof value === 'string') {
          value = Number.parseFloat(value.replaceAll(',', '.'))
        }
        try {
          value = !isNil(value) ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: isNil(this.params.minDecimal) ? 2 : this.params.minDecimal, maximumFractionDigits: this.params.maxDecimal || 2}) : null
        } catch (error) {
          value = null
          console.log(error)
        }
      }
      this.value = value
    }
  }
}
</script>

<style scoped>
div {
  width: 100%;
}
span.na-grid-cell,
span.nref-grid-cell {
  display: block;
  text-align: center;
  position: relative;
  z-index: 6;
  margin: 0 auto;
  right: 17px;
  height: 100%;
  width: calc(100% + 17px + 17px);
  font-weight: 700;
}

span.nref-grid-cell {
  background: #2a2a2acb;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/NumberCellRenderer.vue